import { Avatar, ListItemText, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import { useSelector } from "react-redux";
import React from "react";
import { IReduxState } from "../../store";
import { SITEWEB_SERVER_BASE_URL } from "../../util/apiClient";
import Badge from '@mui/material/Badge';
import { IEnseignantItem } from "../../store/focusEcoleSlice";


export interface IListeProps {
  localDatasFiltered: IEnseignantItem[];
}

const Liste = (props: IListeProps) => {

  const { localDatasFiltered } = props


  return (
    <>
      <div
        style={{
          padding: 10,
          height: "40vh",
          overflow: "auto",
          marginTop: 10
        }}
      >
        <Box sx={{ flexGrow: 1, width: "100%" }}>
          <List dense={true}>
            {localDatasFiltered.map((item, i: number) => {
              return (
                <div key={i}>
                  <ListItem>
                    <ListItemButton>
                      <ListItemText
                        primary={`${item.nomPersonnel} ${item.prenomPersonnel} - ${item?.phone1 ? item?.phone1 : item?.phone2}`}
                        secondary={
                          <Box style={{ display: "flex", flexDirection: "column" }}>
                            <Typography variant="caption">
                              {`${item.libelleMatiereLong}`}
                            </Typography>
                            <Typography variant="caption">
                              {
                                `${item.codeEtab} - ${item.libelleEtab} - ${item.anneeScolaire}`
                              }
                            </Typography>
                          </Box>
                        }
                      />
                    </ListItemButton>
                  </ListItem>
                  <Divider />
                </div>
              );
            })}
          </List>
        </Box>
      </div>
    </>
  );
};
export default Liste;
